// Visual drag preview for Organize master/detail lists.
import {
  TaskItemBase as TaskListItem,
  TaskUIProvider,
} from '@/features/tasks';
import { resolveOrganizeOverlayConfig } from '@/features/organize/components/organizeDragOverlayConfig';

/**
 * Renders the dragged task inside DragOverlay so the source row can stay
 * opacity:0 (use-task-item-styles-presentation) without disappearing.
 *
 * @param {object} props
 * @param {import('@/features/tasks/hooks/list/use-list-dnd').ActiveItem|object|null} props.activeItem
 * @param {Set<string>} [props.duplicateOrderKeyTaskIds]
 * @param {Set<string>} [props.plannedParentIds]
 * @param {Set<string>} [props.waitingForParentIds]
 */
export default function OrganizeDragOverlay({
  activeItem,
  duplicateOrderKeyTaskIds,
  plannedParentIds,
  waitingForParentIds,
}) {
  if (!activeItem?.task) return null;

  const { view, indentationType, variant } =
    resolveOrganizeOverlayConfig(activeItem);

  return (
    <TaskUIProvider
      value={{
        view,
        indentationType,
        duplicateOrderKeyTaskIds,
        plannedParentIds,
        waitingForParentIds,
        selectedTaskIds: [],
        isMultiSelectActive: false,
        onStartAddingSubtask: () => {},
        onRebalance: () => {},
      }}
    >
      <TaskListItem task={activeItem.task} variant={variant} isOverlay />
    </TaskUIProvider>
  );
}
